import { render } from "./DataScienceDetails.vue?vue&type=template&id=7edb89b0"
import script from "./DataScienceDetails.vue?vue&type=script&lang=js"
export * from "./DataScienceDetails.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__